import { T } from 'react-translator-component'

export const parseNotificationMessageType = (type) => {
  switch (type) {
    case 'Available':
      return T('Available')

    case 'Disconnected':
      return T('Disconnected')

    case 'Connected':
      return T('Connected')

    case 'StationBooted':
      return T('Station started')

    case 'TransactionStarted':
      return T('Transaction Started')

    case 'TransactionEnded':
      return T('Transaction Ended')

    case 'Failure':
      return T('Failure')

    case 'Warning':
      return T('Short Recharge')

    default:
      return '...'
  }
}